import { L, vocabulary } from '../define.js';
export const CASE_MANAGEMENT_VOCABULARIES = [
    vocabulary('case_management.article_state', '@vello/case-management ARTICLE_STATES', {
        draft: L('Rascunho', 'Draft', 'Borrador', 'Bozza'),
        in_review: L('Em revisão', 'In review', 'En revisión', 'In revisione'),
        published: L('Publicado', 'Published', 'Publicado', 'Pubblicato'),
        expired: L('Expirado', 'Expired', 'Vencido', 'Scaduto'),
    }),
    vocabulary('case_management.case_priority', '@vello/case-management CASE_PRIORITIES', {
        low: L('Baixa', 'Low', 'Baja', 'Bassa'),
        normal: L('Normal', 'Normal', 'Normal', 'Normale'),
        high: L('Alta', 'High', 'Alta', 'Alta'),
        urgent: L('Urgente', 'Urgent', 'Urgente', 'Urgente'),
    }),
    vocabulary('problem.case_management', '@vello/case-management AppealErrorCode, ArticleErrorCode', {
        WOULD_LOWER: L('Um recurso nunca pode baixar a nota.', 'An appeal can never lower the score.', 'Una apelación nunca puede bajar la puntuación.', 'Un ricorso non può mai abbassare il punteggio.'),
    }, 'message'),
];
//# sourceMappingURL=case-management.js.map